export interface Url {
  Token: string;
  Login: string;
  Logout: string;
  PowerBIComplaints: string;
  PowerBIInhabitRedflag: string;
  PowerBIHestoricalInvestigation: string;
}

export const Url: Url = {
  Token: 'token',
  Login: 'login',
  Logout: 'logout',
  PowerBIComplaints: 'https://app.powerbi.com/groups/me/apps/b8c80efa-f778-43ac-8962-12c49b4ac7fd/instances/5233054',
  PowerBIInhabitRedflag: 'https://app.powerbi.com/groups/me/apps/b8c80efa-f778-43ac-8962-12c49b4ac7fd/instances/5233054',
  PowerBIHestoricalInvestigation: 'https://app.powerbi.com/groups/me/apps/b8c80efa-f778-43ac-8962-12c49b4ac7fd/instances/5233054'
};
